import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getListDrafts, remove } from './templatesActions';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import Table6 from 'common/components/table/table6';
import PrimaryButton from 'common/components/buttons/primaryButton';
import LoadingProgress from 'common/components/progress/loading';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import { Typography, Box } from '@material-ui/core';
import { InputLabelOutlined } from 'common/components/fields/fields';
import { tableSearch } from 'helpers/utils';

function TemplatesDrafts(props) {
  useEffect(() => {
    props.getListDrafts();
  }, []);

  const { router } = props;

  const columns = [
    { title: 'Nome:', field: 'display_name' },
    { title: 'Tipo:', field: 'display_type' },
    { title: 'Descrição:', field: 'display_description' },
  ];

  const [data, setData] = useState([]);
  const [value, setValue] = useState('');

  useEffect(() => {
    setData(props.templatesDrafts.list.content);
  }, [props.templatesDrafts.list.content]);

  function handleChange(e) {
    setData(tableSearch(e, props.news.list.content));
    setValue(e.target.value);
  }

  function handleDelete(id, resolve, reject) {
    props.remove(id, resolve, reject);
  }

  function onRowClick(e, rowData) {
    router.push(`/admin/rascunhos/${rowData.id}/editar`);
  }

  function renderEmptyScreen() {
    return (
      <section
        id="templatesDrafts"
        style={{ marginTop: '4.3em', height: '100vh' }}
      >
        <GeneralGrid container spacing={3} justify="center" alignItems="center">
          <GeneralGrid item xs={12} md={6}>
            <GeneralGrid container spacing={3}>
              <GeneralGrid item xs={12}>
                <div className="pl-4">
                  <h2 className="signup-text">
                    Você ainda não possui rascunhos
                  </h2>
                  <p className="">
                    Seus modelos são as pessoas que são ou não associados da sua
                    empresa. Ao importá-los, você poderá oferecer atividades
                    promocionais para eles.
                  </p>
                  <PrimaryButton
                    onClick={() => props.router.push('/admin/rascunhos/novo')}
                  >
                    Criar Modelos
                  </PrimaryButton>
                </div>
              </GeneralGrid>
            </GeneralGrid>
          </GeneralGrid>
          <GeneralGrid item xs={12} md={6}>
            <img
              src={placeholder_illustration}
              className="img-fluid"
              alt="Não há dados"
            />
          </GeneralGrid>
        </GeneralGrid>
      </section>
    );
  }

  if (props.templatesDrafts.loading) {
    return (
      <Box display="flex" justifyContent="center" height="100vh" mt={7}>
        <LoadingProgress />
      </Box>
    );
  }
  if (props.templatesDrafts.list.content.length < 1) {
    return renderEmptyScreen();
  }

  return (
    <section id="templatesDrafts" style={{ marginTop: '4.3em' }}>
      <GeneralGrid container spacing={3} justify="space-between">
        <GeneralGrid item sm={5} xs={12} md={6} lg={6}>
          <Typography
            style={{ fontFamily: 'Roboto', fontWeight: 500, fontSize: 24 }}
          >
            Lista de Modelos
          </Typography>
          <Typography variant="body1">
            {props.templatesDrafts.list.content.length} modelos
          </Typography>
        </GeneralGrid>
        <GeneralGrid item xs={3}>
          <InputLabelOutlined
            input={{ onChange: handleChange, value: value }}
            meta={{}}
            onChange={handleChange}
            value={value}
            label="Procurar"
            name="search"
            margin="normal"
          />
        </GeneralGrid>
      </GeneralGrid>
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12}>
          <Table6
            title="Rascunhos"
            columns={columns}
            data={data}
            router={router}
            onRowClick={onRowClick}
            remove
            handleDelete={handleDelete}
          />
        </GeneralGrid>
      </GeneralGrid>
    </section>
  );
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    templatesDrafts: state.templatesDrafts,
    general: state.general,
  };
};
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getListDrafts, remove }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesDrafts);
